import { IsArray } from 'class-validator';

export class SearchResponseDto<T> {
  @IsArray()
  readonly docs: T[] = [];
  //this can be a string or a number
  readonly lastPage: any;
}
